import { useState, useMemo } from "react";
import { UserRoundSearch, DoorOpen, FolderOpen, FileText, PieChart } from "lucide-react";

import { mixpanelCustomEvent } from "mixpanel/eventTriggers";
import { MixpanelEventName } from "mixpanel/types";

export const useSidebar = (user: any) => {
  const [collapsed, setCollapsed] = useState(true);
  const [selected, setSelected] = useState<string | null>(null);

  const mixpanelProps = useMemo(
    () => ({ $name: `${user?.name}`, $email: user?.email }),
    [user?.name, user?.email]
  );

  const handleNavigation = (route: string, label: string) => {
    mixpanelCustomEvent({
      mixpanelProps: {
        ...mixpanelProps,
        menuName: label,
      },
      id: user?.id?.toString() || "",
      eventName: MixpanelEventName.userClickedSideBarMenuItem,
    });
    setTimeout(() => {
      window.location.href = route;
    }, 500);
  };

  const navItems = [
    {
      label: "Acquisition Hub",
      key: "acquisitionHub",
      path: process.env.REACT_APP_BUYER_APP_URL,
      icon: <UserRoundSearch className="w-5 h-5" />,
      visible: true,
    },
    {
      label: "Seller Workspace",
      key: "sellerWorkspace",
      icon: <DoorOpen className="w-5 h-5" />,
      path: process.env.REACT_APP_SELLER_APP_URL,
      visible: true,
    },
    {
      label: "Data Room (VDR)",
      key: "vdr",
      path: process.env.REACT_APP_VDR_APP_URL,
      icon: <FolderOpen className="w-5 h-5" />,
      visible: true,
    },
    {
      label: "Docs",
      key: "docs",
      path: process.env.REACT_APP_DOCS_APP_URL,
      icon: <FileText className="w-5 h-5" />,
      visible: true,
    },
    {
      label: "Equity",
      key: "equity",
      path: process.env.REACT_APP_EQUITY_APP_URL,
      icon: <PieChart className="w-5 h-5" />,
      visible: true,
    },
  ];

  return {
    collapsed,
    setCollapsed,
    selected,
    setSelected,
    navItems,
    handleNavigation,
  };
};
